import { createHelpers } from "vuex-map-fields";

export default {
  methods: {
    /**
     * 返回一个可以读写 store 中 states 的对象
     * 依赖：
     * moduleName:string // 模块名称诸如 'carPlan', 'teamShift'
     * 
     * 示例：
     * computed:{
     *  value(){
     *    return reactiveStates({name:'entity.name'})  
     *  }
     * }
     * ---------
     * this.value.name = 123; // 等价于 this.$store.entity.name = 123
     * 对 value.name 的读写将等价与对 store.entity.name 的读写
     * 
     * 对比：           | 触发 mutation | 可以动态添加 |
     * mapStates:      |     false     |  false    |
     * mapFields:      |     true      |  false    |
     * reactiveStates: |     true      |  true     |
     * @param {Object} mapping 名称到 store 中名称的映射
     */
    reactiveStates(mapping){
      const moduleName = this.moduleName;
      if(moduleName == undefined){
        throw new Error('reactiveStates 依赖 this.moduleName')
      }

      const { mapFields } = createHelpers({
        getterType: `${moduleName}/getField`,
        mutationType: `${moduleName}/updateField`
      });
      // 通常将 mapFields 的结果展开
      // 但是这里我们希望将这些对象作为一个整体使用，所以要手动生成访问器
      let getSetMap = mapFields(mapping);

      const result = {};
      Object.keys(getSetMap).forEach(key => {
        Object.defineProperty(result, key, {
          enumerable: true,
          configurable: true,
          get: () => {
            return getSetMap[key].get.call(this);
          },
          set: value => {
            getSetMap[key].set.call(this, value);
          }
        });
      });
      return result;
    }
  },
}